import Plyr from 'plyr'

export default class VideoEmbed {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {}

  init() {
    const player = new Plyr(this.el, {})
  }
}
